// extracted by mini-css-extract-plugin
export default {"button":"PrintResults_button__yCSLY","row":"PrintResults_row__lnj9+"};